import { NgModule } from '@angular/core';
import { LoginComponent } from './pages/login/login.component';
import { SigninCallbackComponent } from './pages/signin-callback/signin-callback.component';
import { SharedModule } from '../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { NotFoundComponent } from './pages/not-found/not-found.component';

@NgModule({
  imports: [SharedModule, CommonModule],
  declarations: [LoginComponent, SigninCallbackComponent, NotFoundComponent],
})
export class UnauthenticatedModule {}
